// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"cfafc9b1","173":"b06539f4","453":"1098b1cf","473":"eb8de0c5","728":"5abed560","838":"d6bd6430","844":"9d4e687f","943":"24af87ac"}[chunkId] + ".chunk.js";
};